import login from './login';

export default {
  language: 'ko-KR',
  country: 'kr',
  name: '한국어',
  embeddedLocale: login,
};
